import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-gift-card-applied',
	standalone: true,
	imports: [
		RouterModule,
		TranslocoPipe
	],
	templateUrl: './gift-card-applied.component.html',
	styleUrls: ['./gift-card-applied.component.css'],
})
export class GiftCardAppliedComponent implements OnInit {

	constructor(
		public activeModal: NgbActiveModal,
		public translate: TranslocoService) { }

	ngOnInit(): void {
	}

}
